import React, { useEffect, useMemo, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Download, AlertTriangle } from "lucide-react";
import { todayISO, formatDateES } from "@/lib/utils-app";
import JustificanteAusenciaForm from "./documents/JustificanteAusenciaForm";

const DOC_TYPES = [
  {
    key: "justificante_ausencia",
    label: "Justificante de Ausencia",
    description: "Documento oficial para justificar la ausencia del alumno por motivos académicos.",
    component: JustificanteAusenciaForm,
  },
];

export default function DocumentsTab() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeDoc, setActiveDoc] = useState("justificante_ausencia");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/students");
        setStudents(data);
      } catch (err) {
        toast.error(formatApiError(err?.response?.data?.detail));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const activeDef = DOC_TYPES.find((d) => d.key === activeDoc);
  const ActiveComponent = activeDef?.component;

  return (
    <div className="max-w-5xl mx-auto space-y-5" data-testid="documents-tab">
      <header>
        <h2 className="text-2xl font-bold flex items-center gap-2">
          <FileText className="h-6 w-6 text-orange-500" />
          Documentos
        </h2>
        <p className="text-sm text-neutral-500 mt-1">
          Genera documentos oficiales en PDF a partir de los datos del alumno.
        </p>
      </header>

      <div className="flex gap-2 flex-wrap">
        {DOC_TYPES.map((d) => (
          <button
            key={d.key}
            type="button"
            onClick={() => setActiveDoc(d.key)}
            data-testid={`doc-type-${d.key}`}
            className={
              "rounded-full border px-4 h-9 text-sm font-semibold transition-colors " +
              (activeDoc === d.key
                ? "bg-orange-500 text-white border-orange-500"
                : "bg-white text-neutral-700 border-neutral-200 hover:bg-neutral-50")
            }
          >
            {d.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-sm text-neutral-500">Cargando alumnos…</div>
      ) : students.length === 0 ? (
        <div className="rounded-xl border border-dashed border-neutral-300 bg-neutral-50 p-8 text-center text-sm text-neutral-500">
          No hay alumnos disponibles. Crea uno desde la pestaña Alumnos.
        </div>
      ) : ActiveComponent ? (
        <ActiveComponent students={students} />
      ) : null}
    </div>
  );
}

export { DOC_TYPES };
